<template>
    <section class="main-container">
        <div class="select">
            <ui-select-v2
                v-model="form.product"
                :data="options.products"
                :loading="loader.products"
                :disabled="options.products.length == 0 || isSearching"
                :required="isRequired.product"
                return-value="id"
                label="Empreendimento:"
                item-label="name"
                design="br-default"
                @input="selectProductHandler"
            />
        </div>
        <div v-if="showCustoms && hasProduct" class="select" :style="selectCustomsStyle">
            <ui-select-v2
                v-if="!isVertical"
                v-model="form.block"
                :data="options.blocks"
                :loading="loader.blocks"
                :disabled="options.blocks.length == 0 || isSearching"
                label="Quadra:"
                item-label="label"
                return-value="value"
                design="br-default"
                @input="selectBlockHandler"
            />
            <ui-select-v2
                v-if="isVertical"
                v-model="form.block"
                :data="options.blocks"
                :loading="loader.blocks"
                :disabled="options.blocks.length == 0 || isSearching"
                label="Torre:"
                :search="false"
                item-label="label"
                return-value="value"
                design="br-default"
                @input="selectBlockHandler"
            />
            <ui-select-v2
                v-if="isVertical"
                v-model="form.floor"
                :data="floorOptionsComputed"
                :loading="loader.floors"
                :disabled="floorOptionsComputed.length == 0  || isSearching"
                label="Andar:"
                item-label="label"
                return-value="value"
                design="br-default"
                @input="selectFloorHandler"
            />
        </div>
        <div v-if="showUnits && hasProduct" class="select">
            <ui-select-v2
                v-model="form.unity"
                :data="unitsOptionsComputed"
                :loading="loader.units"
                :disabled="unitsOptionsComputed.length == 0"
                label="Unidade:"
                item-label="label"
                design="br-default"
                return-value="object"
            />
        </div>
    </section>
</template>

<script>
	import { uiSelectV2 } from '@/components/ui/form'

	import { alertMixin, loaderMixin } from '@/mixins'

	import { availability, product } from '@/services/axios'


	const defaultForm = () => ({
		real_product: null,
		product: null,
		product_object: null,
		product_type: 'vertical',

		unity: null,
		block: null,
		floor: null,
	})

	const defaultOptions = () => ({
		products: [],
		units: [],
		blocks: [],
		floor: [],
	})

	const defaultLoader = () => ({
		products: false,
		units: true,
		blocks: false,
		floors: false,
	})

	const defaultRequired = () => ({
		product: false,
	})

	export default {
		name: 'ui-nugget-product-form',

		components: {
			uiSelectV2,
		},

		mixins: [loaderMixin, alertMixin],

		props: {
			/**
			 * Se ativado, o componente mostrará a seleção de unidades
			 */
			showUnits: {
				type: Boolean,
				required: false,
				default: false,
			},
			/**
			 * Se ativado, o componente mostrará a selação de quadra/torre e andar do empreendimento
			 */
			showCustoms: {
				type: Boolean,
				required: false,
				default: true,
			},
			/**
			 * Se ativado, o componente resetará os dados ao ser iniciado
			 */
			needsReset: {
				type: Boolean,
				required: false,
				default: false,
			},
			/**
			 * Pegue o valor das options e joga pra cima, assim como v-model
			 */
			fetchList: {
				type: Object,
				default: () => ({})
			},
			/**
			 * Pegue o valor dos loaders e joga pra cima, assim como v-model
			 */
			loaderList: {
				type: Object,
				default: () => ({})
			},
			/**
			 * Recebe o ID do nugget para event listener
			 */
			nuggetId: {
				type: [String, Number],
				default: ''
			},
			/**
			 * Recebe um objeto contendo o inputs obrigatórios.
			 */
			requiredFileds: {
				type: Object,
				default: () => ({}),
			},
			/**
			 * Define se irá ser retornado o real product_id do empreendimento ao invés do availability_id
			 * O real product_id é necessário para algumas telas, como o novo modal de cadastro de clientes, por exemplo
			 */
			needRealProductId: {
				type: Boolean,
				default: false,
			},
			/**
			 * Define se o componente irá trazer os empreendimentos com sistema de reserva ativo
			 * ou todos os empreendimentos
			 */
			reserveSystem: {
				type: Boolean,
				default: true,
			}
		},

		data() {
			return {
				form: { ...defaultForm() },
				options: { ...defaultOptions() },
				loader: { ...defaultLoader() },

				nuggetName: 'nugget-product-form',

				allUnits: [],

				preSelected: { },
				unity_id : null,
				isSearching : false
			}
		},

		computed: {
			isRequired() {
				return {
					...defaultRequired(),
					...this.requiredFileds,
				}
			},

			hasProduct() {
				return this.form.product && !Array.isArray(this.form.product)
			},

			selectCustomsStyle() {
				return this.isVertical
					? 'display: grid; grid-template-columns: 1fr 1fr; grid-column-gap: 15px'
					: 'display: block;'
			},

			isVertical() {
				return this.form.product_type == 'vertical'
			},

			floorOptionsComputed() {
				let options = []

				if (!this.isVertical) return options

				if (this.form.block) {
					options = this.options.floor.filter((item) => {
						return item.block == this.form.block
					})
				}

				return options
			},

			nuggetTotalName() {
				return this.nuggetName + (this.nuggetId ? '-' + this.nuggetId : '')
			},

			unitsByFloorComputed() {
				return this.allUnits.filter((item) => {
					return item.floor == this.form.floor
				})
			},

			unitsOptionsComputed()	{
				let units = this.options.units

				units.map((unity) => {
					unity.label = `Unidade ${unity.number} ${unity.description ? ' / ' + unity.description : ''}`
				})

				return units
			},
		},

		watch: {
			options: {
				handler(newVal) {
					this.$emit('update:fetchList', newVal)
				},

				deep: true,
			},

			loader: {
				handler(newVal) {
					this.$emit('update:loaderList', newVal)
				},

				deep: true,
			},

			form(newVal) {
				this.$emit('input', newVal)
			},
		},

		async mounted() {
			this.$emit('input', this.form)

			this.$root.$on(this.nuggetTotalName, async (data, preSelected = null) => {
				this.preSelected = preSelected;
				if (!preSelected && this.form.product && this.form.product_object && !this.needsReset) return

				this.reset()

				await this.loadProducts()

				if (preSelected && preSelected.id) {
					this.form.product = parseInt(preSelected.id)
					await this.selectProductHandler()

					if (preSelected.block) {
						///Aqui faz a requisição certa
						if(!this.form.block) await this.loadUnits(this.form.product_object.availability_id, preSelected.block)
						this.form.block = preSelected.block

						if (preSelected.floor && !['null', 'undefined'].includes(preSelected.floor)) {
							this.form.floor = preSelected.floor
							await this.selectFloorHandler()
						}

						let unit = null
						if (preSelected.unit &&
							(unit = this.options.units.find(unit => unit.id == preSelected.unit))) {
							this.form.unity = unit

							// Envia as unidades selecionadas para o component reserve-wrapper-list
							this.options.units = Object.values(this.options.units).map(unit => {
								unit.check = unit.id == preSelected.unit
								return unit
							})
						}
					}
				}

				// Checks if data has been received
				if (data) {
					//Cai nessa condicional se abrir o modal pelo botão selecione do header
					//Se tiver o id da unidade não deve fazer requisição com o block[0]
					this.form.product = parseInt(data.product_id)
					this.unity_id = data.unity_id;
					// Checks if there is already a unit assigned to the deal
					await this.selectProductHandler()
					if (data.unity_id) await this.automaticUnitySelection(data.unity_id)
				}
			})

			this.$root.$on('clean--' + this.nuggetTotalName, () => {
				this.reset()
			})
		},

		beforeDestroy() {
			this.$root.$off(this.nuggetTotalName)
			this.$root.$off('clean--' + this.nuggetTotalName)
		},

		methods: {
			modAllOptionsLoader(value) {
				this.$mx_setLoader('blocks', value)
				this.$mx_setLoader('floors', value)
				this.$mx_setLoader('units', value)
			},

			async loadProducts() {
				try {
					this.$mx_setLoader('products', true)

					// Capture products
					const { data } = this.reserveSystem ? await product.getHasReserve() : await product.getAll('')

					// Add received data
					this.options.products = [...data]

					this.$mx_setLoader('products', false)
				} catch (error) {
					this.$mx_setLoader('products', false)
					this.$mx_alertError(error)
				}
			},

			async getUnityInfos(id) {
				try {
					const { data } = await product.getUnity(id)
					return data.data
				} catch (error) {
					return null
				}
			},

			prepareBlocks(data) {
				let lastBlock = null

				data.forEach((item) => {
					if (this.isVertical) {
						if (item.block != lastBlock) {
							lastBlock = item.block

							this.options.blocks.push({
								...item,
								label: `Torre ${item.block}`,
								value: item.block,
							})
						}

						return
					}

					if (item.block != lastBlock) {
						lastBlock = item.block

						this.options.blocks.push({
							...item,
							label: `Quadra ${item.block}`,
							value: item.block,
						})
					}
				})
			},

			async selectProductHandler() {
				// Reset values
				this.resetData()
				if (!this.hasProduct) {
					this.$mx_setLoader('units', false)
					return
				}
				try {
					this.modAllOptionsLoader(true)
					this.form.product_object = this.options.products.find(productItem => productItem.id == this.form.product)

					// The selected product is not available or does not exist.
					if (!this.form.product_object) {
						this.$mx_alertError('O Empreendimento selecionado não está disponível ou não existe. Selecione outro Empreendimento.')

						// Reset this for select new product
						this.form.product = null
						this.modAllOptionsLoader(false)

						return
					}
					// Okay, lets get the type of product. Is it horizontal or vertical?
					if (this.form.product_object.availability) this.form.product_type = this.form.product_object.availability.type
					else this.form.product_type = this.form.product_object.infos.uauProductType
					// Alright, update real_product value
					if (this.needRealProductId) this.form.real_product = this.form.product_object.id
					// Change the flow if the product is UAU
					if (this.form?.product_object?.infos?.reserve?.integration == 'apiuau') {
						await this.selectUAUProductHandler()
						return
					}
					// const withoutAvailability = String(this.form.product).includes('SEM availability_id ::') ? true : false
					const withoutAvailability = this.form?.product_object?.availability?.id ? false : true
					if (withoutAvailability) {
						this.modAllOptionsLoader(false)
						return
					}
					const { data } = await availability.getBlocksV2(this.form.product_object.availability.id)
					if (!data || !data.length) {
						this.modAllOptionsLoader(false)
						return
					}
					// Prepare normal blocks
					this.prepareBlocks(data)

					// Checks if you dont already have a block selected
					//isso aqui deve acontecer
					if (!this.form.block || this.form.block == '') this.form.block = this.options.blocks[0].block
					// Apply all units

					if(this.preSelected?.block && this.preSelected?.block != this.form.block){
						this.form.block = this.preSelected?.block;
						await this.loadUnits(this.form.product_object.availability_id, this.form.block)
						this.modAllOptionsLoader(false)
						return
					}

					if (!this.preSelected && !this.unity_id && this.preSelected  || !this.unity_id) {
						await this.loadUnits(this.form.product_object.availability_id, this.form.block)
					}

					//await this.loadUnits(this.form.product_object.availability_id, this.form.block)
					this.modAllOptionsLoader(false)
				} catch (error) {
					this.modAllOptionsLoader(false)
					if (error.data?.msg) {
						this.$mx_alertError(error.data.msg)
					} else {
						this.$mx_alertError(error)
					}

					if (error.data?.details) {
						this.$root.$emit('has-permissions-details', error?.data?.details)
					}
				}
			},

			prepareUAUUnits(data) {
				let lastBlock = null
				let lastUnity = null

				Object.entries(data).forEach(([key, value]) => {
					Object.entries(value).forEach(([_key2, value2]) => {
						if (value2 == lastUnity) return

						const queue = this.form.product_object.infos.reserve &&
							this.form.product_object.infos.reserve.queueReserve &&
							this.form.product_object.infos.reserve.queueReserve.status === 'active';
						const withQueue = queue ? 6 : ''

						let toModify = value2

						toModify.id = toModify.numper_unid
						toModify.number = toModify.unity
						toModify.cost = toModify.valortotal && toModify.valortotal != 'null' ? toModify.valortotal : 0
						toModify.situation = toModify.vendido_unid != 2 ? 1 : withQueue

						toModify.reference = toModify.unity
						toModify.title = this.form.product_object.name
						toModify.description = toModify.identificador_unid

						toModify.check = false
						toModify.isUAU = true

						this.options.units.push(toModify)
						this.allUnits.push(toModify)

						lastUnity = value2
					})

					if (key == lastBlock) return

					this.options.blocks.push({
						label: key,
						value: key,
					})

					lastBlock = key
				})
			},

			async selectUAUProductHandler() {
				try {
					const { data } = await product.getUAUBlocksUnits(
						this.form.product_object.infos.uauBusinessKey,
						this.form.product_object.infos.uauProductKey,
						this.form.product_object.infos.uauProductType,
						this.form.product
					)

					if (!data) {
						this.modAllOptionsLoader(false)
						return
					}

					if (data && data.status == 'error')
						throw new Error(data.msg)

					// Prepare UAU product units
					this.prepareUAUUnits(data)
					this.modAllOptionsLoader(false)
				} catch (error) {
					this.modAllOptionsLoader(false)
					this.$mx_alertError(error)
				}
			},

			async selectBlockHandler() {
				// Reset values
				this.form.unity = null
				this.form.floor = null

				if (this.form?.product_object?.infos?.reserve?.integration == 'apiuau') {
					if (!this.form.block || Array.isArray(this.form.block)) {
						this.options.units = this.allUnits
						return
					}

					this.options.units = this.allUnits.filter((item) => {
						return item.block == this.form.block
					})

					return
				}

				this.options.units = []
				this.options.floor = []

				this.allUnits = []

				if (!this.form.block || Array.isArray(this.form.block)) {
					await this.selectProductHandler()
					return
				}

				if(!this.preSelected && !this.unity_id || !this.preSelected && this.unity_id || this.preSelected  && !this.unity_id){
					await this.loadUnits(this.form.product_object.availability_id, this.form.block)
				}
			},

			async selectFloorHandler() {
				// Reset values
				this.form.unity = null

				if (!this.form.floor || Array.isArray(this.form.floor)) {
					await this.selectProductHandler()
					return
				}

				this.options.units = this.unitsByFloorComputed
			},

			prepareUnits(data) {
				let toModify = data

				toModify.map((item) => {
					let info = ''

					if (item.floor && item.floor != '') {
						if (item.infos && item.infos.typology) {
							if (item.floor == 0) info = `Térreo - `
							else info = `${item.floor}º andar - `
							info += `${item.infos.typology} - `
						}

						if (item.block) info += `Torre ${item.block} - `
						if (item.garage) info += `Garagem - `
						if (item.area) info += `${item.area} m²`
					} else {
						if (item.block) info += `Quadra ${item.block} - `
						if (item.infos && item.infos.typology) info += `${item.infos.typology} - `
						if (item.garage) info += `Garagem - `
						if (item.area) info += `${item.area} m²`
					}

					item.reference = item.number
					item.title = this.form.product_object.name
					item.description = info
					item.check = false
					item.isUAU = false

					return item
				})

				this.options.units = toModify
				this.allUnits = toModify
			},

			prepareFloor(data) {
				let lastFloor = null

				data.forEach((item) => {
					if (item.floor != lastFloor) {
						lastFloor = item.floor
						//remover itens duplicado
						let set = this.options.floor.filter(val => {
							return item.id == val.id ? true : false
						})
						if(set.length > 0) return
						this.options.floor.push({
							...item,
							label: +item.floor ? `Andar ${item.floor}` : 'Térreo',
							value: item.floor,
						})
					}
				})
			},

			async loadUnits(availabilityId, block) {
				if(this.isSearching)  return;
				this.isSearching = true;
				// Reset values
				this.form.unity = null

				try {
					this.$mx_setLoader('units', true)

					const { data } = await product.getAvailabilityBlockUnits(availabilityId, block)
					if (!data || !data.length) {
						this.isSearching = false;
						this.$mx_setLoader('units', false)
						return
					}
					this.prepareFloor(data)
					this.prepareUnits(data)
					this.$mx_setLoader('units', false)
				} catch (error) {
					this.$mx_setLoader('units', false)
					this.$mx_alertError(error)
				}
				this.isSearching = false;
			},

			async automaticUnitySelection(unityId) {
				if (!this.hasProduct) {
					return
				}

				this.modAllOptionsLoader(true)

				try {
					const unityInfos = await this.getUnityInfos(unityId)

					// Set unity infos
					this.form.block = unityInfos.block
					this.form.floor = unityInfos.floor
					await this.loadUnits(this.form.product_object.availability_id, this.form.block)
					if (unityInfos.floor && unityInfos.floor != '') await this.selectFloorHandler()

					const unity = this.options.units.find((unityFiltered) => unityFiltered.id == unityInfos.id)

					// Cannot get the unity
					if (!unity) {
						this.modAllOptionsLoader(false)
						return
					}

					// Pass the selected unity to reserve-wrapper-list
					this.form.unity = unity
					this.options.units.map((unityMap) => {
						if (unityMap.id == unityInfos.id)
							unityMap.check = true
					})
				} catch (error) {
					this.$mx_alertError(error)
				}

				this.modAllOptionsLoader(false)
			},

			resetData() {
				this.form.real_product = null
				this.form.product_object = null

				this.form.unity = null
				this.form.block = null
				this.form.floor = null

				this.options.blocks = []
				this.options.floor = []
				this.options.units = []

				this.allUnits = []
			},

			reset() {
				this.form = { ...defaultForm() }
				this.options = { ...defaultOptions() }
				this.loader = { ...defaultLoader() }

				this.allUnits = []
			},
		},
	}
</script>

<style lang="stylus" scoped>
	@import 'styles.styl'
</style>